const ImportStates = {
    Idle: 1,
    Pending: 2,
    Preview: 3,
    Importing: 4,
    Fail: 5,
    Complete: 6,
} as const;

export type ImportState =
    | typeof ImportStates.Idle
    | typeof ImportStates.Pending
    | typeof ImportStates.Preview
    | typeof ImportStates.Importing
    | typeof ImportStates.Fail
    | typeof ImportStates.Complete;

export default ImportStates;
